"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var formatters = require("./formatters");
var checkType = require("./check-type");
var DateTime = require("./output/datetime");
var parsers = require("./parsers");
var moment = require("moment");
var parse = function parse(value, format, timezone) {
  var dateCannotParse = function dateCannotParse() {
    return null;
  };
  var formatString = _typeof(format) === "string" ? format : formatters.dateString(format);
  var type = checkType(value);
  if (type === "moment" || type === "date") {
    return new DateTime(value, formatString, timezone);
  } else if (type === "object") {
    var momentDate = parsers.datetimeObject(value, formatString, timezone);
    return parse(momentDate, formatString, timezone);
  } else if (type === "string") {
    var _momentDate = parsers.moment(value, formatString, timezone);
    if (!_momentDate.isValid()) {
      return dateCannotParse();
    }
    return parse(_momentDate, formatString, timezone);
  }

  // Basically :shrug:. This isn't actually needed for trial project but let's be nice
  return dateCannotParse();
};
module.exports = parse;